/**
 * ZFilterPills — Zephyr OS Design System
 *
 * Universal filter pill component. One component, all apps, same shape and behavior.
 * Spec: design-system.md Section 7 (Filter Pills).
 */

export default function ZFilterPills({
  options = [],
  selected,
  onChange,
  accent = '#6B35B8',
  multi = false,
}) {
  const isSelected = (id) => {
    if (multi && Array.isArray(selected)) return selected.includes(id);
    return selected === id;
  };

  const handleClick = (id) => {
    if (multi) {
      const arr = Array.isArray(selected) ? [...selected] : [];
      if (arr.includes(id)) {
        onChange(arr.filter((x) => x !== id));
      } else {
        onChange([...arr, id]);
      }
    } else {
      onChange(selected === id ? null : id);
    }
  };

  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {options.map((opt) => {
        const active = isSelected(opt.id);
        return (
          <button
            key={opt.id}
            onClick={() => handleClick(opt.id)}
            style={{
              background: active ? `${accent}1A` : 'transparent', // 1A = ~10%
              border: `1px solid ${active ? `${accent}40` : 'rgba(255,255,255,0.08)'}`, // 40 = ~25%
              color: active ? accent : '#6b7084',
              borderRadius: 20,
              padding: '6px 14px',
              fontSize: 12,
              fontFamily: "'Inter', -apple-system, sans-serif",
              fontFeatureSettings: '"cv01", "ss03"',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 150ms ease',
              whiteSpace: 'nowrap',
            }}
            onMouseEnter={(e) => {
              if (!active) {
                e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)';
                e.currentTarget.style.color = '#b0b4c0';
              }
            }}
            onMouseLeave={(e) => {
              if (!active) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
                e.currentTarget.style.color = '#6b7084';
              }
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
